import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import TOOLBAR_PAINTING from '@tencent/docs-design-resources/pc/svg/toolbar_painting.svg';
import TOOLBAR_PARAGRAPH from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph.svg';
import TOOLBAR_FONT_SETTING from '@tencent/docs-design-resources/pc/svg/toolbar_font_setting.svg';
import i18n from '@i18next/i18n';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';

export const FOLD_ICON_TYPE = {
    PAINTING: 'painting',
    PARAGRAPH: 'paragraph',
    FONT_SETTING: 'font_setting',
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: wrapIdForBig(FOLD_ICON_TYPE.PAINTING),
        icon: <img src={TOOLBAR_PAINTING} alt={''}/>,
        text: i18n.t('绘图'),
        tooltip: i18n.t('绘图'),
        hasArrow: true,
        style: {
            width: 'auto',
        },
    },
    {
        name: wrapIdForBig(FOLD_ICON_TYPE.PARAGRAPH),
        icon: <img src={TOOLBAR_PARAGRAPH} alt={''}/>,
        text: i18n.t('段落'),
        tooltip: i18n.t('段落'),
        hasArrow: true,
        style: {
            width: 'auto',
        },
    },
    {
        name: wrapIdForBig(FOLD_ICON_TYPE.FONT_SETTING),
        icon: <img src={TOOLBAR_FONT_SETTING} alt={''}/>,
        text: i18n.t('字体'),
        tooltip: i18n.t('字体'),
        hasArrow: true,
        style: {
            width: 'auto',
        },
    },
];
